import React, { useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import "./MyLoginPage.css"; // 引入纯 CSS 样式
import authProvider from "../../authProvider";
import { useNavigate } from "react-router-dom";

export const MyLoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");


  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      // 直接调用 authProvider.login（会做前端哈希并把 token 存 localStorage）
      await authProvider.login({ username, password });
      // 清除明文密码引用
      setPassword("");
      // 登录成功后跳转到根或你想要的页面
      navigate("/");
    } catch (err: any) {
      const errorCode = err?.message || "LOGIN_FAILED";
      
      // 根据错误代码显示友好的错误信息
      switch (errorCode) {
        case 'INVALID_CREDENTIALS':
          setError('Invalid username or password. Please try again.');
          break;
        case 'ACCOUNT_DISABLED':
          setError('Your account has been disabled. Please contact administrator.');
          break;
        case 'SERVER_ERROR':
          setError('Server error. Please try again later.');
          break;
        case 'LOGIN_FAILED':
        default:
          setError('Login failed. Please check your credentials and try again.');
          break;
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo-container">
          <img src="/images/company.png" alt="Bodco Dairy" className="logo" />
        </div>
        <h2 className="title">Welcome to Bodco Dairy System</h2>

        <form onSubmit={handleLogin} className="login-form">
          {/* Username */}
          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="input-field"
            />
          </div>

          {/* Password */}
          <div className="input-group">
            <FaLock className="input-icon" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="input-field"
            />
          </div>

          {/* Remember me + Forgot password */}
          <div className="options">
            <label className="remember-me">
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
              />
              Remember me
            </label>
            <a href="/forgot-password" className="forgot-password">
              Forgot password?
            </a>
          </div>

          {error && <div className="error-msg">{error}</div>}

          <button type="submit" className="login-btn">
            Log On
          </button>
        </form>

        <div className="footer">© 2025 Bodco Dairy</div>
      </div>
    </div>
  );
};

export default MyLoginPage;
